export default __webpack_public_path__ + "static/media/sbp.390a725b.svg";